// NBL1_Player Pages
import rules from "../../Data/Rules"
import functions from "../../Data/Functions"
import settings from "../Settings/NBL1_Settings"
import Verification from "../Steps/Verification"
import Base_Details from "../Steps/BaseDetails"
import store from "../../veux/store"

let Countries, PlayingStatus, Clubs, Conference, BqRegoLink
let showUniform = true
let PlayerAccred
let step1, step2


// NBL1 Player Step Schema
const Load_NBL1_Player_Steps = () => {
    return {
        Portal: '2024 NBL1 Player',
        MainColor: "#f5924c",
        Logo: require(`../../assets/${Conference.logo}`),
        Title: `<h2>Mitsubishi ${Conference.Name} 2024 Player Registration Form</h2>`,
        Description: `I HEREBY APPLY to be registered with ${Conference.Organisation} 
                (${Conference.abbrev}) for the 2024 ${Conference.Name} season. I acknowledge 
                that my information will be retained and used by ${Conference.abbrev} 
                and the NBL to meet its obligations in administering the league and 
                to ensure the registered person can be contacted when required for Tribunal, 
                Integrity or COVID related matters.
                <br><br>
                All registered persons should note, in accordance with the Basketball Australia 
                (BA) National Integrity Framework. BA may share personal information relating 
                to Participants with Betting Operators, law enforcement agencies, government 
                agencies or other sporting organisations to prevent and investigate match-fixing 
                incidents.
                <br></br>
                <b>Please note all submitted registrations are PENDING approval subject to accreditation and clearance status<br>
                No new player may register to play post the cut off period for finals qualification</b>`,
        Model: {},
        steps: [
            // Step 1
            step1,
            // Step 2
            step2,
            // Step 3
            {
                stepno: 3,
                title: 'Rego',
                valid: true,
                information: '',
                Schema: {
                    DOB: {
                        type: 'text',
                        ext: 'date',
                        locale: 'en',
                        label: `Date of Birth (${store.getters.getdateFormat})`,
                        outlined: true,
                        dense: true,
                        mask: store.getters.getdateMask,
                        rules: [rules.requiredMsg('Date of Birth is Required'),
                        rules.minAge(`The NBL1 has a minimum age in all divisions that a player 
                                    must turn at least 14 years of age during
                                    the year in which the player seeks to register. 
                                    You are not eligible to register for this current competition year`, '2010-01-01')],
                        class: 'mx-1 px-1',
                        onInput: (ev, portal) => {
                            if ((new Date(ev.data.DOB) > new Date('2008-04-09')) && (new Date(ev.data.DOB) < new Date('2010-01-01'))) {
                                ev.schema.Indeminity.hidden = false
                                ev.schema.Indeminity.rules = [rules.requiredMsg('Under Aged Signed Indeminity Form is Required')]
                            } else {
                                ev.schema.Indeminity.hidden = true;
                                ev.schema.Indeminity.rules = []
                            }
                        },
                        OUG: { Contacts: { Field: "date_of_birth" } }
                    },
                    Indeminity: {
                        type: 'file',
                        label: 'Please upload duly authorised Indeminity Form',
                        multiple: false,
                        outlined: true,
                        dense: true,
                        hidden: true,
                        col: 12,
                        accept: "image/*,application/pdf",
                        rules: [rules.fileSize()],
                        class: 'mx-1 px-1',
                        Startslot: `<h4 style="text-align:center;color:red"><i>As you are sixteen (16) years of age or younger at the commencement of the season,  
                                a parent must complete and sign in the presence of the Association delegate, 
                                an indemnification form provided by the league in recognition that the NBL1 
                                is a senior competition. </h4></i><br></br>
                                
                                <a href=${settings.LoadExtForm('U16', Conference.Code_id)} target="blank">
                                Contact your Association Delegate to complete </a>`,
                        OUG: {
                            Contact_Details: {
                                Type: 1867,
                                Action: "SingleDesc",
                                Description: 'U16 Signed Indeminity Form',
                            }
                        }
                    },
                    GenderAB: {
                        type: "select",
                        label: "Gender At Birth",
                        outlined: true,
                        dense: true,
                        hidden: Conference.Code_id != 3031,
                        rules: (Conference.Code_id != 3031) ? [] : [rules.requiredMsg('Gender At Birth is Required')],
                        class: 'mx-1 px-1',
                        items: ['Male', 'Female'],
                        value: '',
                        OUG: { Contact_Details: { Type: 3723, Action: "Unique" } },
                    },
                    birthCountry: {
                        type: 'select',
                        label: 'Country of Birth?',
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Country of Birth is Required')],
                        class: 'mx-1 px-1',
                        items: Countries,
                        value: '',
                        OUG: { Contact_Details: { Type: 3394, Action: "Unique" } }
                    },
                    PlayingStatus: {
                        type: "select",
                        label: "Playing Status",
                        outlined: true,
                        dense: true,
                        class: 'mx-1 px-1',
                        rules: [rules.requiredMsg('Playing Status is Required')],
                        items: PlayingStatus,
                        value: '',
                        OUG: { Contact_Details: { Type: 3366, Action: "Unique" } }
                    },
                    Proof: {
                        type: 'file',
                        label: 'Passport / Citizenship',
                        multiple: false,
                        outlined: true,
                        hidden: store.getters.passport,
                        // hidden: Conference.Code_id === 3032 ? true : store.getters.passport,
                        dense: true,
                        accept: "image/*,application/pdf",
                        rules: (store.getters.passport) ? [] : [rules.requiredMsg('Passport / Citizenship is Required'), rules.fileSize()],
                        // rules: (Conference.Code_id === 3032 ? true : store.getters.passport) ? [] : [rules.requiredMsg('Passport / Citizenship is Required')],
                        class: 'mx-1 px-1',
                        OUG: {
                            Contact_Details: {
                                Type: 1867,
                                Action: "SingleDesc",
                                Description: 'Passport or proof of Citizenship',
                            }
                        },
                    },
                    hasProof: {
                        type: 'text',
                        dense: true,
                        disabled: true,
                        hidden: !store.getters.passport,
                        // hidden: Conference.Code_id === 3032 ? true : !store.getters.passport,
                        class: 'mx-1 px-1',
                        Startslot: `<H4 style="text-align:center;color:red">We have already sighted your Passport or proof of Citizenship</H4>`
                    },
                    CompSelect: {
                        "type": "select",
                        "label": "Competition Selection",
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Competition Selection is Required')],
                        class: 'mx-1 px-1',
                        items: settings.CompType,
                        onInput: async (ev, portal) => {
                            Clubs = await settings.LookupTeams({
                                State_Champs: Conference.Code_id,
                                Gender: functions.getCompGender(ev.data.CompSelect)
                            })
                            ev.schema.Club.items = Clubs

                            ev.schema.IndigNBL.hidden = true
                            ev.schema.IndigNBL.rules = []
                            // Check if Indigenious status
                            if (ev.data.Indigenous && (ev.data.Indigenous.includes("Aboriginal") ||
                                (ev.data.Indigenous.includes("Torres Strait")))) {

                                if (ev.obj.value == 'Male Competition') {
                                    ev.schema.IndigNBL.hidden = false
                                    ev.schema.IndigNBL.rules = [rules.requiredMsg('Share Contact Information is required')]
                                    ev.schema.IndigNBL.Startslot = `<p style="text-align:center;color:lightgreen;font-size:12px;">
                                        <b>Do you give permission for your contact information to be shared with the NBL, ${Conference.abbrev},
                                        Adelaide 36ers, Brisbane Bullets, Cairns Taipans, Illawarra Hawks, Melbourne United, Perth Wildcats, 
                                        South East Melbourne Phoenix, Sydney Kings, Tasmania JackJumpers, for the purpose of the 
                                        NBL’s Indigenous Player Classification
                                        </p>`
                                }
                                if (Conference.Code_id == 3031) {
                                    if (ev.obj.value == 'Female Competition') {
                                        ev.schema.IndigNBL.hidden = false
                                        ev.schema.IndigNBL.rules = [rules.requiredMsg('Share Contact Information is required')]
                                        ev.schema.IndigNBL.Startslot = `<p style="text-align:center;color:lightgreen;font-size:12px;">
                                            <b>Do you give permission for your contact information to be shared with the WNBL(BA) and Basketball Victoria 
                                            for the purpose of the WNBL’s Indigenous Player Classification
                                            </p>`
                                    }
                                }

                            } else {
                                ev.schema.IndigNBL.hidden = true
                                ev.schema.IndigNBL.rules = []
                            }
                            if (Conference.Code_id === 3031) {
                                ev.schema.RSLLogo.hidden = false
                                ev.schema.RSLVet.hidden = false
                                ev.schema.RSLVet.rules = [rules.requiredMsg('Served in the Australian Defence Forces is required')]
                                ev.schema.RSLVetOther.hidden = false
                                ev.schema.RSLVetOther.rules = [rules.requiredMsg('Family who Served in the Australian Defence Forces is required')]
                            } else {
                                ev.schema.RSLLogo.hidden = true
                                ev.schema.RSLVet.hidden = true
                                ev.schema.RSLVet.rules = []
                                ev.schema.RSLVetOther.hidden = true
                                ev.schema.RSLVetOther.rules = []
                            }
                        }
                    },
                    Club: {
                        "type": "select",
                        "label": "Which Club are you registering for?",
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Club is Required')],
                        class: 'mx-1 px-1',
                        items: Clubs,
                        returnObject: true,
                        itemText: 'Detail',
                        Role: 1,
                        Accreditation: PlayerAccred,
                        AccredStart: '',
                        AccredEnd: '',
                        noDataText: 'Please Enter Competition Selection First',
                        AccredTeam: Conference.Code_id,
                        onInput: async (ev, portal) => {
                            if (Conference.Code_id === 3034) {
                                if (portal.Model.Club.Association === 3062) {
                                    ev.schema.BQRego.hidden = true
                                } else {
                                    ev.schema.BQRego.hidden = false
                                    BqRegoLink = `<a href="${settings.LoadBQRegoLink(portal.Model.Club.Association)}" target="_blank">Click Here</a>`
                                    let BQExpDate = functions.getBQExpiry()
                                    if (BQExpDate > settings.ConfEndDate) {
                                        ev.schema.BQRego.Endslot = `<h3 style="text-align:center;color:green"> Your Basketball Connect BQ Registration is current and will expire on 
                                        ${functions.FormatDate(BQExpDate, 'DD/MM/YYYY')} which is after the end of the 2024 NBL1 Competition.</h3>`
                                    } else {
                                        // if (portal.Model.BQExpiryDate && portal.Model.BQExpiryDate > settings.ConfEndDate) {
                                        //     ev.schema.BQRego.Endslot = `<h3 style="text-align:center;color:green"> Your Basketball Connect BQ Registration is current and will expire on 
                                        //     ${functions.FormatDate(portal.Model.BQExpiryDate, 'DD/MM/YYYY')} which is after the end of the 2024 NBL1 Competition.</h3>`
                                        // } else {
                                        ev.schema.BQRego.Endslot = `<h3 style="text-align:center;color:red"><p>Your Basketball Connect BQ Registration either could not be found 
                                        or is due to expire before the end of the 2024 NBL1 Competition</p>
                                        <p>This will have to be rectified before your registration will be approved
                                        </p>
                                        <p>Please use the link below to update your registration</p>
                                        <p>${BqRegoLink}</p></h3>`
                                    }
                                }
                            }
                        },
                        OUG: { Contact_Roles: true, Type: "Teams" }
                    },
                    Position: {
                        type: "select",
                        label: "Playing Position",
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Playing Position is required')],
                        class: 'mx-1 px-1',
                        items: settings.PlayerRoles,
                        value: '',
                        OUG: { Contact_Details: { Type: 346, Action: "Unique" } }
                    },
                    IndigNBL: {
                        addText: " to Permission to Share Contact Information",
                        type: "select",
                        label: "Permission to Share Contact Information",
                        outlined: true,
                        dense: true,
                        hidden: true,
                        rules: [],
                        class: 'mx-1 px-1',
                        items: ["Yes", "No", "Rather Not Say"],
                        value: '',
                        col: 12,
                        Startslot: `<p style="text-align:center;color:lightgreen;font-size:12px;">
                            <b>Do you give permission for your contact information to be shared with the NBL, ${Conference.abbrev},
                            Adelaide 36ers, Brisbane Bullets, Cairns Taipans, Illawarra Hawks, Melbourne United, Perth Wildcats, 
                            South East Melbourne Phoenix, Sydney Kings, Tasmania JackJumpers, for the purpose of the 
                            NBL’s Indigenous Player Classification
                        </p>`,
                        OUG: {
                            Contact_Details: {
                                Type: 3369,
                                Action: "SingleDesc",
                                Description: 'Permission to Share Contact Information',
                            }
                        }
                    },
                    RSLLogo: {
                        type: 'img',
                        hidden: true,
                        col: 12,
                        src: `https://admin.ownurgoal.net.au/_lib/file/OUGImages/RSL_Vic_Logo.png`,
                        width: "50%",
                        contain: true,
                        class: "ma-auto",
                    },
                    RSLVet: {
                        addText: " in the Australian Defence Forces",
                        type: "select",
                        label: "I have served in the Australian Defence Forces",
                        outlined: true,
                        dense: true,
                        hidden: true,
                        rules: [],
                        class: 'mx-1 px-1',
                        items: ["No - I have not Served", "Yes - I have Served", "Rather Not Say - if I Served"],
                        value: '',
                        col: 12,
                        Startslot: `<p style="text-align:center;color:lightgreen;font-size:12px;">
                                <b>As part of BV's partnership with RSL Victoria, please can you advise if you have served in the Australian Defence Forces including Reservists</b>
                                </p>`,
                        OUG: {
                            Contact_Details: {
                                Type: 3865,
                                Action: "SingleDesc",
                                Description: 'Served in the Australian Defence Forces',
                            }
                        }
                    },
                    RSLVetOther: {
                        addText: "  to family member served in the Australian Defence Forces",
                        type: "textarea",
                        label: "Family members who served",
                        outlined: true,
                        dense: true,
                        hidden: true,
                        rules: [],
                        class: 'mx-1 px-1',
                        items: ["No", "Rather Not Say", "Spouse", "Parent", "Grandparent", "Sibling", "Child", "Aunty", "Uncle", "Other"],
                        value: '',
                        col: 12,
                        Startslot: `<p style="text-align:center;color:lightgreen;font-size:12px;">
                            <b>Has a member of your family (spouse, parent, grandparent, sibling, child, aunty or uncle) ever served in the Australia Defence Forces including Reservists?
                        </p>`,
                        OUG: {
                            Contact_Details: {
                                Type: 3865,
                                Action: "SingleDesc",
                                Description: 'Family Served in the Australian Defence Forces',
                            }
                        }
                    },
                    Height: {
                        id: "353",
                        type: 'number',
                        label: 'Height (cms)',
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Height is Required')],
                        class: 'mx-1 px-1',
                        OUG: { Contact_Details: { Type: 353, Action: "Unique" } },
                    },
                    RepBasketball: {
                        addText: " played NBL1 or any other senior representative basketball",
                        type: 'select',
                        label: 'Have you played NBL1 or any other senior representative basketball before?',
                        outlined: true,
                        dense: true,
                        col: 12,
                        rules: [rules.requiredMsg('NBL1 or other Senior Rep Basketball is Required')],
                        class: 'mx-1 px-1',
                        items: ["Yes", "No"],
                        onInput: (ev, portal) => {
                            if (ev.data.RepBasketball == "No") {
                                ev.schema.DiffAssociation.hidden = true
                                ev.schema.DiffAssociation.rules = []
                            } else {
                                ev.schema.DiffAssociation.hidden = false;
                                ev.schema.DiffAssociation.rules = [rules.requiredMsg('Different Association is Required')]
                            }
                        },
                        OUG: {
                            Contact_Details: {
                                Type: 704,
                                Action: "SingleDesc",
                                Description: ({ data }) => { return data.RepBasketball },
                            }
                        },
                    },
                    DiffAssociation: {
                        addText: "",
                        type: 'select',
                        label: 'Are you registering for a DIFFERENT ASSOCIATION to last registered for NBL1?',
                        hidden: true,
                        outlined: true,
                        dense: true,
                        col: 12,
                        rules: [],
                        class: 'mx-1 px-1',
                        items: [
                            "NO - I played with this NBL1 Association the last time I played senior representative basketball and will NOT require a clearance",
                            "Yes – The last time I played was for a different Association and I have gained Clearance approval through my new Destination Association"
                        ],
                        Startslot: `Are you registering for a DIFFERENT ASSOCIATION to who you last registered and played NBL1 for ? OR you last played for another state or international association?`,
                        onInput: (ev, portal) => {
                            if (ev.data.DiffAssociation == "NO - I played with this NBL1 Association the last time I played senior representative basketball and will NOT require a clearance") {
                                ev.schema.PrevAssociation.hidden = true
                                ev.schema.PrevAssociation.rules = []
                            } else {
                                ev.schema.PrevAssociation.hidden = false;
                                ev.schema.PrevAssociation.rules = [rules.requiredMsg('Details of Previous Association is Required')]
                            }
                        },
                        OUG: {
                            Contact_Details: {
                                Type: 704,
                                Action: "SingleDesc",
                                Description: ({ data }) => { return data.DiffAssociation },
                            }
                        },
                    },
                    PrevAssociation: {
                        type: 'text',
                        label: 'Who was the last association you registered for ?',
                        hidden: true,
                        outlined: true,
                        dense: true,
                        col: 12,
                        rules: [],
                        class: 'mx-1 px-1',
                        Startslot: `Who was the last association you registered for? Please detail the year of registration, 
                                league and association. e.g. Year: 2015, League: NBL1, Previous association`,
                        Endslot: `<b>Note - Clearances are not required from local competitions</b>`,
                        OUG: { Contact_Details: { Type: 1170, Action: "Unique" } }
                    },
                    CollegePlayer: {
                        Contact_Details: "354",
                        unique: true,
                        addText: " returning to Australia from playing college basketball",
                        type: 'select',
                        label: 'Are you returning to Australia from playing college basketball?',
                        outlined: true,
                        dense: true,
                        col: 12,
                        rules: [rules.requiredMsg('Returning College Player is Required')],
                        class: 'mx-1 px-1',
                        items: ["Yes", "No"],
                        onInput: (ev, portal) => {
                            if (ev.data.CollegePlayer == "No") {
                                ev.schema.RetCollege.hidden = true
                                ev.schema.RetCollege.rules = []
                            } else {
                                ev.schema.RetCollege.hidden = false;
                                ev.schema.RetCollege.rules = [rules.requiredMsg('Intentions of returing to College is Required')]
                            }
                        },
                        OUG: { Contact_Details: { Type: 354, Action: "Unique" } }
                    },
                    RetCollege: {
                        addText: "",
                        type: 'select',
                        label: 'Are you intending on going back to college ?',
                        hidden: true,
                        outlined: true,
                        dense: true,
                        col: 12,
                        rules: [],
                        class: 'mx-1 px-1',
                        items: ["Yes - I will be going back to college (e.g currently on a gap year, holidays)",
                            "No – I am fully back in Australia from college and will not be returning and I have gained BA International Clearance approval",
                            "Undecided"],
                        Endslot: `<h4 class="slot">
                            <b>If you are intending to go back to college, you are not required to submit for a BA International Clearance.
                            </p>If however you have played NBL1 before and are intending on playing at a different NBL1 Association, your Destination Association will be required to submit for a clearance approval from your previous NBL1 Association.
                            </b>
                        </h4>`,
                        OUG: { Contact_Details: { Type: 3714, Action: "Unique" } }
                    },
                    BQRego: {
                        type: 'text',
                        label: 'Basketball Connect BQ Registration Status',
                        disabled: true,
                        col: 12,
                        hidden: true,
                    }
                },
                PreStep: (thisStep, portal) => {
                    let { Model, Schema } = thisStep

                    store.getters.birthCountry ? portal.Model.birthCountry = store.getters.birthCountry : null
                    store.getters.birthCountry ? Schema.birthCountry.value = store.getters.birthCountry : null
                    store.getters.PlayingStatus ? portal.Model.PlayingStatus = store.getters.PlayingStatus : null
                    store.getters.PlayingStatus ? Schema.PlayingStatus.value = store.getters.PlayingStatus : null

                    Schema.Proof.hidden = store.getters.passport
                    Schema.Proof.rules = (store.getters.passport) ? [] : [rules.requiredMsg('Passport / Citizenship is Required')]
                    Schema.hasProof.hidden = !store.getters.passport

                },
            },
            // Step 4
            {
                stepno: 4,
                title: 'Integrity',
                valid: true,
                information: `<div style="padding-bottom: 25px; line-height: 200%">
                    All Players must complete or provide proof of completion for the following E-Learning sessions provided by Sport Integrity Australia and Basketball Australia to complete your registration and compete in ${Conference.Name}.
                    <br><br>
                    <h4>Sport Integrity Australia</h4>
                    1. <a href="https://elearning.sportintegrity.gov.au/login/index.php" target="_blank">SIA Anti Doping Fundamentals Course</a>
                    - <b>COMPLETE ONCE (NEW PLAYERS/PLAYERS THAT HAVE NOT COMPLETED)</b>
                    <br>
                    2. <a href="https://elearning.sportintegrity.gov.au" target="_blank">SIA 2024 Annual Update   </a>
                     (after completion of SIA Anti-Doping Fundmentals Course) - <b>COMPLETE ANNUALLY</b>
                    <br><br>
                    
                    <h4>Basketball Australia</h4>
                    3. <a href="https://basketballaustralia.etrainu.com/training/?event=course.purchase&bundleID=3F0F3FD7-A729-42C2-9F88-41CA9C6B5C97&secret=5E2104A0-BE72-CB0A-62F8BC01C42F51F2" target="_blank">BA Gambling and Match-Fixing Course</a>
                    - <b>COMPLETE ONCE (NEW PLAYERS/PLAYERS THAT HAVE NOT COMPLETED)</b>
                    <br> 
                    4. BA Face to Face Integrity Session - <b>COMPLETE ANNUALLY</b>
                    <br><br>
                    If you have already completed these courses and need to retrieve your proof of completion, please click the relevant link below:
                    <br>
                    <a href="https://elearning.sportintegrity.gov.au/login/index.php" target="_blank">Retrieve SIA Anti-Doping & Annual Update Badges</a>
                    <br>
                    <a href="https://basketballaustralia.etrainu.com/training/index.cfm?event=page.login" target="_blank">Retrieve BA Gambling and Match-Fixing Certifcate</a>
                </div>`,
                Schema: {
                    MatchFixing: {
                        type: 'file',
                        label: 'Basketball Australia Gambling and Match Fixing Course Certificate',
                        multiple: false,
                        outlined: true,
                        hidden: store.getters.integrity,
                        dense: true,
                        accept: "image/*,application/pdf",
                        rules: (store.getters.integrity) ? [] : [rules.requiredMsg('Introduction to Match-Fixing Certificate is Required'), rules.fileSize()],
                        class: 'mx-1 px-1',
                        OUG: {
                            Contact_Details: {
                                Type: 1867,
                                Action: "SingleDesc",
                                Description: "BA Integrity Gambling & Match Fixing Certificate",
                            }
                        },
                        Startslot: `<p style="text-align:center;color:lightgreen;font-size:12px;">Basketball Australia Gambling and Match Fixing Course Certificate – (Please upload a screenshot of your Certificate <a href="https://admin.ownurgoal.net.au/_lib/file/doc/GamblingMatchFixingExample.jpg" target="blank">Click Here for Example</a>)</p>`
                    },
                    haveMatchFixing: {
                        type: 'text',
                        dense: true,
                        disabled: true,
                        hidden: !store.getters.integrity,
                        class: 'mx-1 px-1',
                        Startslot: `<H4 style="text-align:center;color:red">We already have a copy of your BA Integrity Gambling & Match Fixing Certificate</H4>`
                    },
                    AnnualUpdate2024: {
                        type: 'file',
                        label: "Annual Update 2024 Certificate",
                        multiple: false,
                        outlined: true,
                        // hidden: (Conference.Code == 3033),
                        dense: true,
                        accept: "image/*,application/pdf",
                        // rules: (Conference.Code == 3033) ? [] : [rules.requiredMsg('Annual Update 2024 Certificate is Required')],
                        rules: [rules.requiredMsg('Annual Update 2024 Certificate is Required'), rules.fileSize()],
                        class: 'mx-1 px-1',
                        OUG: {
                            Contact_Details: {
                                Type: 1867,
                                Action: "SingleDesc",
                                Description: "Annual Update 2024 Certificate",
                            }
                        },
                        Startslot: `<p style="text-align:center;color:lightgreen;font-size:12px;">SIA badges – (Please upload a screenshot of your SIA Badges page <a href="https://admin.ownurgoal.net.au/_lib/file/doc/SIAExample.jpg" target="blank">Click Here for Example</a>, which must show the SIA Anti-Doping Fundamentals badge, AS WELL AS the SIA 2024 annual update badge)</p>`
                    },
                    BAIntegrity: {
                        type: 'checkbox',
                        label: `Please check this box if you agree to abide by Basketball Australia's National Integrity Framework`,
                        color: "primary",
                        value: "I Agree to BA National Integrity Framework",
                        rules: [rules.requiredMsg('Confirmation of acceptance of BA Integrity Framework is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Integrity Requirements</h3>`,
                        Endslot: `<h4 class="slot">
                            I agree to abide with the BA National Integrity Framework, BA may share personal information relating to Participants with Betting Operators, law enforcement agencies, government agencies or other sporting organisations to prevent and investigate match-fixing incidents.
                            <br>
                            <a href="https://australia.basketball/integrity/" target="_blank">Click here to review National Integrity Framework</a>
                        </h4>`,
                        OUG: { Answer: true }
                    },
                },
                PreStep: (thisStep, portal) => {
                    let { Model, Schema } = thisStep
                    // Schema.MatchFixing.hidden = store.getters.integrity
                    // Schema.MatchFixing.rules = (store.getters.integrity) ? [] : [rules.requiredMsg('Introduction to Match-Fixing Certificate is Required')]
                    // Schema.haveMatchFixing.hidden = !store.getters.integrity
                },
            },
            // Step 5
            {
                stepno: 5,
                title: 'Confirmation',
                valid: true,
                information: ``,
                Schema: {
                    COVID: {
                        type: 'checkbox',
                        label: `I have read and agree to abide to any ${Conference.Organisation} determinations on participation eligibility at any point relatable to COVID 19 or other.`,
                        color: "primary",
                        value: "I Agree to abide by COVID requirements",
                        hidden: (Conference.Code_id === 3034),
                        rules: (Conference.Code_id === 3034) ? [] : [rules.requiredMsg('Confirmation of acceptance of COVID Requirements is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>COVID Requirements</h3>`,
                        Endslot: `<a href=${settings.LoadExtForm('COVID', Conference.Code_id)} target="blank">
                            ${Conference.Organisation} Vaccination Requirements</a>`,
                        OUG: { Answer: true }
                    },
                    Participate: {
                        type: 'checkbox',
                        label: `I have read and agree to the terms and conditions of participation 
                            in NBL1. As laid out in the ${Conference.Name} Rules`,
                        color: "primary",
                        value: "I Agree to all Terms and Conditions for NBL1",
                        rules: [rules.requiredMsg('Confirmation of acceptance of Terms and Conditions is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Participation Requirements</h3>`,
                        Endslot: `<a href=${settings.LoadExtForm('T&Cs', Conference.Code_id)} target="blank">
                            ${Conference.Name} Rules</a>`,
                        OUG: { Answer: true }
                    },
                    showUniformDetails: {
                        type: 'img',
                        hidden: false,
                        src: `${settings.LoadExtForm('Uniform', Conference.Code_id)}`,
                        // height: "800px",
                        // width: "100%",
                        //maxHeight: 1366,
                        //maxWidth: 768
                        contain: true,
                        class: "ma-2"
                    },
                    uniformConfirm: {
                        type: 'checkbox',
                        label: `I agree to abide by ${Conference.Organisation}'s Compression Garment Policy`,
                        color: "primary",
                        value: "I Agree to abide by Compression Garment Policy",
                        rules: [rules.requiredMsg('Confirmation of Compression Garment Policy is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Uniform Requirements</h3>`,
                        OUG: { Answer: true }
                    },
                    foreignPlayer: {
                        type: 'checkbox',
                        label: `I agree that if I do not currently have Australian Citizenship, I will gain Basketball Australia approval each competition year so I am eligible to play in any NBL1 match.`,
                        color: "primary",
                        value: "I Confirm I meet Foreign Player Conditions",
                        rules: [rules.requiredMsg('Confirmation of Foreign Player Requirement is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Foreign Player Requirements</h3>`,
                        Endslot: `<a href="https://www.australia.basketball/get-involved/pathways/immigration" target="blank">
                            Basketball Australia Immigration Policy (non current Australian Citizens)</a>`,
                        OUG: { Answer: true }
                    },
                    cocConfirm: {
                        type: 'checkbox',
                        label: `I confirm that I will adhere to the ${Conference.Organisation} Code of Conduct`,
                        color: "primary",
                        value: "I Confirm I will adhere to Code of Conduct",
                        rules: [rules.requiredMsg('Confirmation of Code of Conduct is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Code of Conduct Requirements</h3>`,
                        Endslot: `<a href=${settings.LoadExtForm('COC', Conference.Code_id)} target="blank">
                            ${Conference.Organisation} Code of Conduct</a>`,
                        OUG: { Answer: true }
                    },
                    useImages: {
                        type: 'checkbox',
                        label: `I acknowledge that ${Conference.abbrev}, 
                        ${Conference.Name} and my Club may use images, 
                        video, or similar of me for the promotion of the League
                        and the Club.`,
                        color: "primary",
                        value: "I Acknowledge use of my Images and Video",
                        rules: [rules.requiredMsg('Use of Images confirmation is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Images Requirements</h3>`,
                        OUG: { Answer: true }
                    },
                    attendTribunal: {
                        type: 'checkbox',
                        label: `I undertake to attend meetings of the ${Conference.Organisation} Tribunal whenever required to do so and consent to the subsequent reporting of the proceedings of such meetings and hearings.`,
                        color: "primary",
                        value: "I Agree to attend Tribunal or other meetings",
                        rules: [rules.requiredMsg('Agreement to Attend is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Tribunal Requirements</h3>`,
                        OUG: { Answer: true }
                    },
                    agreeToAudit: {
                        type: 'checkbox',
                        label: `As part of the ${Conference.Name} competition rules, four clubs are subject to an auditing process each year at seasons end. Please note by registering as a player in the West conference, you are agreeing to potentially being contacted at any time, as part of the auditing process – to be asked general questions surrounding any match payments`,
                        color: "primary",
                        hidden: Conference.Code_id != 3033,
                        value: "I Agree to attend Tribunal or other meetings",
                        rules: (Conference.Code_id != 3033) ? [] : [rules.requiredMsg('Agreement to be Contacted is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Audit Requirements</h3>`,
                        OUG: { Answer: true }
                    },
                    Concussion: {
                        type: 'checkbox',
                        label: `I confirm that I will adhere to the ${Conference.Organisation} Concussion Protocols`,
                        color: "primary",
                        value: "I Confirm I will adhere to NBL1 Concussion Protocols",
                        rules: (Conference.Code_id === 3033 || Conference.Code_id === 3032) ? [] : [rules.requiredMsg('Confirmation of NBL1 Concussion Protocols is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        hidden: (Conference.Code_id === 3033 || Conference.Code_id === 3032),
                        Startslot: `<h3>Concussion Requirements</h3>`,
                        Endslot: `<a href=${settings.LoadExtForm('Concussion', Conference.Code_id)} target="blank">
                                            ${Conference.Organisation} Concussion Protocols</a>`,
                        OUG: { Answer: true }
                    },
                    infoAccurate: {
                        type: 'checkbox',
                        label: 'I confirm that I have provided infomation honestly and that it is both true and accurate.',
                        color: "primary",
                        value: "I Confirm information all honest and correct",
                        rules: [rules.requiredMsg('Accurate Information confirmation is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Information Requirements</h3>`,
                        OUG: { Answer: true }
                    }
                },
            },
            // Step 6
            {
                stepno: 6,
                title: 'Finish',
                valid: true,
                information: `Thank you for your submitted registration for the 2024 NBL1 season.</br></br>
                Please note this submitted registration is <b>PENDING APPROVAL</b> from the league and will be reviewed.<br></br>
                You and your association delegate will receive an email notification once this has been approved by the league and 
                you will then be assigned to the teams roster and be able to be selected to play on game day as an eligible player.<br></br>
                <hr><br></br>
                Please stay up to date with all NBL1 news and information throughout the season on the <a href="https://nbl1.com.au/" target="blank">NBL1 website</a><br></br>
                Please also note that 9 games are required to be played to qualify for finals !`,
                Schema: {}
            }
        ]
    }
}



export default {

    LoadSchema: async (Parameters) => {
        Conference = settings.ConfDetails.find((ele) => {
            return Parameters.Conference == ele.Code_id;
        })
        step1 = await Verification.LoadSchema(1)
        step2 = await Base_Details.LoadSchema(2)
        Countries = await functions.GetCountries();
        PlayingStatus = await functions.GetCodeBy({ Type: "NBL1 Playing Status" });
        ({ PlayerAccred } = settings.LoadExtAccreds(Conference.Code_id))
        return Load_NBL1_Player_Steps()
    },



}

